import config from "@config";

// The fault vocabulary is owned by the case domain elsewhere in the RMA
// backend - kept in sync by hand here so the customer's options and the
// agent's options don't drift apart.
export const FAULT_OPTIONS = [
  "Leakage",
  "Function",
  "Connectivity",
  "Station",
  "Suction",
  "Others",
];

export const CLAIM_TYPES = ["DOA", "Warranty Service claim", "Other"];

// The backend's lowercase claim type codes for POST /ticket/public-create/.
export const CLAIM_TYPE_CODES = {
  DOA: "doa",
  "Warranty Service claim": "warranty_service_claim",
  Other: "other",
};

// The backend's lowercase fault type codes for POST /ticket/public-create/.
const FAULT_TYPE_CODES = {
  Leakage: "leakage",
  Function: "function",
  Connectivity: "connectivity",
  Station: "station",
  Suction: "suction",
  Others: "others",
};

export function toFaultTypeCode(fault) {
  return FAULT_TYPE_CODES[fault] ?? fault;
}

export const UPLOAD_CATEGORIES = [
  "Proof of Purchase (POP)",
  "Proof of Return (POR)",
  "Fault photo / video",
  "Other",
];

// Customers only provide proof of purchase - proof of return is a retailer document.
export const CUSTOMER_UPLOAD_CATEGORIES = UPLOAD_CATEGORIES.filter(function (category) {
  return category !== "Proof of Return (POR)";
});

// The backend's category codes for POST /ticket/public-create/attachments/.
const UPLOAD_CATEGORY_CODES = {
  "Proof of Purchase (POP)": "proof_of_purchase",
  "Proof of Return (POR)": "proof_of_return",
  "Fault photo / video": "fault_photo_video",
  Other: "other",
};

export function toAttachmentCategoryCode(category) {
  return UPLOAD_CATEGORY_CODES[category];
}

export const YES_NO_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

// The backend's cosmetic condition keys - sent as-is in `cosmetic_condition`.
export const COSMETIC_CONDITION_OPTIONS = [
  { value: "no_damage", label: "No visible damage" },
  { value: "minor", label: "Yes - Minor cosmetic damage (e.g. scratches, scuffs, dents)" },
  {
    value: "major",
    label: "Yes - Major physical damage (e.g. cracks, broken parts, significant dents)",
  },
  { value: "other", label: "Other" },
];

// Who is lodging the request - decides which fields are asked.
export const SUBMITTER_TYPE_OPTIONS = [
  { value: "customer", label: "Customer" },
  { value: "retailer", label: "Retailer" },
];

// Whose email receives notifications - only asked when a retailer is lodging.
export const PRIMARY_EMAIL_OPTIONS = [
  { value: "retailer", label: "Retailer" },
  { value: "customer", label: "Customer" },
];

export const COUNTRY_OPTIONS = [
  { value: "AU", label: "Australia" },
  { value: "NZ", label: "New Zealand" },
];

// An address's country follows the brand site's country and is not editable.
export const DEFAULT_COUNTRY = config.country.toUpperCase() === "NZ" ? "NZ" : "AU";

// Proof of return is not collected for warranty service claims - the unit is
// being serviced, not returned.
export function requiresProofOfReturn(claimType) {
  return claimType !== "Warranty Service claim";
}
